import React from 'react';

import Logo from '../assets/images/logo.svg';

/**
 * Header section
 */
const Header = () => {
    return (
        <header className="main-head">
            <img src={Logo} alt="infince" />
        </header>
    );
};

export default Header;
